import React, { ReactElement } from 'react'
import { logo, maintenanceIcon } from '../assets/images/images'

function Maintenance(): ReactElement {
  return (
    <>
      <div className="containerFluid miw0 flexGrow1">
        <div className="row hFull">
          <div className="colMd6 offsetMd3">
            <div className="card textCenter hFull pt5 pb5 px3 px7md">
              <div>
                <img src={logo} className="dBlock w5 mt03 mb5" alt="Logo" />
              </div>
              <div className="pt10md">
                <img
                  src={maintenanceIcon}
                  alt="Maintenance Icon"
                  className="h10"
                />
                <div className="mt25 mb25">
                  <h1 className="mb1 errorPageTitle textGray-500">
                    Le service est momentanément indisponible :(
                  </h1>
                  <p className="fontSizeXs lh16 textGray-500">
                    Nous mettons tout en œuvre pour y remédier dans les
                    meilleurs délais.
                  </p>
                  <p className="fontSizeXs lh16 textGray-500">
                    Veuillez nous excuser pour la gêne occasionnée.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Maintenance
